import { Dispatch } from "redux";
import { setAxnCacheRefreshResults, setAxnCacheRefreshing } from "@redux/actions/axn-cache-actions";
import { refreshAxnCacheRequest } from "@requests/management-console/refresh-axn-cache";
import { RefreshResult } from "@idw-types/common";
import { logAndDisplayErrorModal } from "@utils/app-alert-util";
import { resources } from "@constants/hardcoded-strings";

export const refreshAxnCacheReduxRequest = (dispatch: Dispatch) => async (): Promise<Array<RefreshResult>> => {
    dispatch(setAxnCacheRefreshResults(null, null));
    dispatch(setAxnCacheRefreshing(true));
    const { data, error } = await refreshAxnCacheRequest();

    const lastRefreshDate = new Date();

    if (data) {
        dispatch(setAxnCacheRefreshResults(data, lastRefreshDate));
        return data;
    } else {
        if (error) {
            logAndDisplayErrorModal(
                dispatch,
                error,
                resources.requests.refreshAxnCache.error.title,
                resources.requests.refreshAxnCache.error.message
            );
        }
        dispatch(setAxnCacheRefreshResults(null, lastRefreshDate));
        return null;
    }
};